const gregorian_tr = {
    name: "gregorian_tr",
    months: [
      ["Ocak", "Oca"],
      ["Şubat", "Şub"],
      ["Mart", "Mar"],
      ["Nisan", "Nis"],
      ["Mayıs", "May"],
      ["Haziran", "Haz"],
      ["Temmuz", "Tem"],
      ["Ağustos", "Ağu"],
      ["Eylül", "Eyl"],
      ["Ekim", "Eki"],
      ["Kasım", "Kas"],
      ["Aralık", "Ara"],
    ],
    weekDays: [
      ["cumartesi", "ct"],
      ["pazar", "pz"],
      ["pazartesi", "pt"],
      ["salı", "sa"],
      ["çarşamba", "ça"],
      ["perşembe", "pe"],
      ["cuma", "cu"],
    ],
    digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    meridiems: [
      ["AM", "am"],
      ["PM", "pm"],
    ],
  };
  
  export default gregorian_tr;